import React from 'react';
import { IonList, IonItem, IonThumbnail, IonImg, IonLabel, IonText } from '@ionic/react';
import { useHistory } from 'react-router';
import { _dict } from '../constants';
import { useGlobalStore } from '../stateManagement/globalZustand';
import { opacity } from 'html2canvas/dist/types/css/property-descriptors/opacity';


interface Item {
    image: string;
    title: string;
    description: string;
    disabled: boolean;
    goToUrl: string;
    disabledNote: string;

}

interface QListProps {
    items: Item[];
    
}

const QList: React.FC<QListProps> = ({ items }) => {
    const history = useHistory();
    return (
        <IonList>
            {items.map((item, index) => (<>
                <IonItem
                key={index}
                style={{ opacity: item.disabled ? 0.5 : 1 }}
                onClick={()=> {!item.disabled ? history.push(item.goToUrl || '') : alert(item.disabledNote)}}
                >

                    <IonThumbnail key="tb" slot="start">
                        <IonImg src={item.image} />
                    </IonThumbnail>
                    <IonText key="tt">
                        <b>{item.title}</b>:
                    </IonText>
                    <IonText key="ds">
                        {item.description}
                        
                    </IonText>
                </IonItem>
                
                </>
            ))}
        </IonList>
    );
};

export default QList;
